import { type ReactNode } from 'react';

import { YStack } from '@/components/ui/layout/layout';

import {
  WIKI_FACT_KIND_HEADINGS,
  type WikiFact,
  type WikiLookupRun,
} from '../people-wiki.types';

import { FactRow } from './fact-row';
import { SectionHeading } from './section-heading';

/** The facts of a person's page, by kind. The remove action and the add button come in from outside. */
export const PersonFacts = ({
  facts,
  lookup,
  onRemoveFact,
  addFact,
}: {
  facts: WikiFact[];
  lookup: WikiLookupRun | null;
  onRemoveFact: (factId: string) => void;
  addFact: ReactNode;
}) => (
  <YStack className="items-start gap-3">
    <SectionHeading title="Facts" />
    {facts.length === 0 ? (
      <span className="text-sm text-foreground-subtle">
        {lookup && lookup.status !== 'running'
          ? 'Nothing confirmed from the web yet.'
          : 'Nothing here yet.'}
      </span>
    ) : (
      Object.entries(WIKI_FACT_KIND_HEADINGS).map(([kind, heading]) => {
        const kindFacts = facts.filter((fact) => fact.kind === kind);
        return (
          kindFacts.length > 0 && (
            <YStack key={kind} className="gap-2">
              <h3 className="text-xs font-medium text-foreground-muted">
                {heading}
              </h3>
              <YStack className="gap-3">
                {kindFacts.map((fact) => (
                  <FactRow
                    key={fact.id}
                    fact={fact}
                    onRemove={() => onRemoveFact(fact.id)}
                  />
                ))}
              </YStack>
            </YStack>
          )
        );
      })
    )}
    {addFact}
  </YStack>
);
